export const normalizeAddressValue = (value) => {
    if (value === null || value === undefined || value === false) return "";
    return String(value).trim();
};

export const hasAddressData = (address) => {
    if (!address) return false;
    return [
        address.cups_id_provincia,
        address.cups_id_municipi,
        address.cups_id_poblacio,
        address.cups_tv,
        address.cups_nv,
        address.cups_dp,
        address.cups_aclarador,
    ].some((val) => normalizeAddressValue(val) !== "");
};

export const addressesMatch = (left, right) => {
    if (!left || !right) return false;

    const keys = [
        "cups_tv",
        "cups_nv",
        "cups_pt",
        "cups_pu",
        "cups_es",
        "cups_pnp",
        "cups_dp",
        "cups_aclarador",
        "cups_id_pais",
        "cups_id_provincia",
        "cups_id_municipi",
        "cups_id_poblacio",
    ];

    return keys.every((key) => normalizeAddressValue(left[key]) === normalizeAddressValue(right[key]));
};

export const shouldAutoUseClientAddress = (savedOfferAddress, clientAddress) => {
    if (!hasAddressData(savedOfferAddress)) return false;
    return addressesMatch(savedOfferAddress, clientAddress);
};
